import { Node_Type } from 'ricos-schema';

const verticalEmbedProviders = { event: "event", booking: "booking", product: "product" };
const contentTypeMap = {
  EVENT: "Events",
  BOOKING: "Bookings",
  PRODUCT: "Stores"
};
const verticalEmbedModals = {
  insertBooking: `${Node_Type.APP_EMBED}.insertBooking`,
  insertProduct: `${Node_Type.APP_EMBED}.insertProduct`,
  insertEvent: `${Node_Type.APP_EMBED}.insertEvent`,
  replace: `${Node_Type.APP_EMBED}.replace`
};

export { contentTypeMap, verticalEmbedModals, verticalEmbedProviders };
//# sourceMappingURL=constants.js.map
